import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const logout = ({ access, refresh }) =>
  Manager.client(access).post(Endpoints.auth.logout, { token: refresh });

export const Request = {
  logout,
};
